import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetXeroTokenFromCodeMutation } from "../../../store/xero-integration/xeroApi";

const XeroCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [getXeroToken] = useGetXeroTokenFromCodeMutation();

  const getQueryParams = () => {
    const queryParams = new URLSearchParams(location.search);
    return { code: queryParams.get("code") };
  };

  const { code } = getQueryParams();

  const handleXeroAuth = async () => {
    try {
      const response = await getXeroToken(code || "").unwrap();
      localStorage.setItem("xeroAccessToken", response.access_token);
      localStorage.setItem("xeroRefreshToken", response.refresh_token);
      navigate("/settings");
    } catch (error) {
      console.error("Xero Auth Error:", error);
    }
  };

  useEffect(() => {
    if (code) {
      handleXeroAuth();
    }
  }, [code]);

  return <div>Loading...</div>;
};

export default XeroCallback;
